/* eslint-disable no-console */
import { setStream } from "@/store/slices/webrtc-slice";
import store from "@/store/store";
import { randomString } from "@/utils";
import SimplePeer from "simple-peer";

import { buildRTCIceConfig } from "./webrtcConfig";

export class Peer {
  /** @type {string} */
  id = "";

  /** @type {SimplePeer.Instance} */
  peer = null;

  /** @type {MediaStream | null} */
  stream = null;

  constructor(id = randomString(10)) {
    this.peer = new SimplePeer(buildRTCIceConfig());
    this.peer.addTransceiver("video", {
      direction: "recvonly",
    });
    this.id = id;
  }

  /**
   * @description handshake with server
   */
  onSignal = (peer, onConnection) => {
    return async (data) => {
      try {
        let token = window.btoa(JSON.stringify(data));
        const response = await onConnection(token);
        let answer = window.atob(response);
        peer.signal(answer);
      } catch (error) {
        console.log("error from signal", error);
        return;
      }
    };
  };

  /**
   * @description dispatch actions on starting stream
   */
  onStream = (stream) => {
    store.dispatch(setStream({ stream, cameraId: this.id }));
  };

  /**
   *
   * @param {(token: string) => string} onConnection
   * @returns
   */
  connect = (onConnection) => {
    if (onConnection == null) {
      throw new Error("onConnection is required");
    }
    this.peer.on("error", (err) => {
      console.log("error in peer connection", err);
    });
    this.peer.on("connect", () => {
      console.log("peer connected");
    });
    this.peer.on("close", () => {
      console.log("peer connection is closed");
    });
    this.peer.on("signal", this.onSignal(this.peer, onConnection));
    this.peer.on("stream", this.onStream);
    return this;
  };

  /**
   * @description destroy stream from memory to free resources
   */
  disconnect = () => {
    this.peer.destroy();
  };

  static createPeers = (ids) => ids.map((id) => new Peer(id).connect());
}
